<template>
  <v-stepper
    v-model="value"
    class="mt-3 mb-5">
    <v-stepper-header>
      <template
        v-for="(item, index) in items">
        <v-stepper-step
          :key="`step-${index}`"
          :step="item.id"
          :color="isValid(item.id) ? 'success': 'primary'"
          :complete="isValid(item.id)">
          {{ item.title }}
        </v-stepper-step>
        <v-divider
          v-if="index < items.length - 1"
          :key="`div-${index}`" />
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>

export default {
  name: 'Stepper',
  components: {
  },
  props: {
    value: {
      type: Number,
      default: 1,
    },
    items: {
      type: Array,
      default: () => ([]),
    },
    sessionKeyPrefix: {
      type: String,
      default: null,
    },
  },
  methods: {
    isValid(step) {
      return this.value > step
    },
  },
}
</script>
